var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDunbradstreet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "m8.418 7.557 10.237 10.622-1.07 1.027-1.629-1.67-1.584 1.542a3.68 3.68 0 0 1-2.784 1.07 3.77 3.77 0 0 1-2.742-1.198 3.68 3.68 0 0 1-1.07-2.784c0-1.028.428-2.014 1.199-2.742l1.07-1.027 1.029 1.07-1.071 1.028a2.24 2.24 0 0 0-.728 1.67c0 .643.214 1.243.685 1.714a2.24 2.24 0 0 0 1.67.728c.643 0 1.242-.214 1.714-.685l1.585-1.542L8.418 9.74zM17.797 10.384a3.68 3.68 0 0 1 1.071 2.784 3.77 3.77 0 0 1-1.2 2.74l-.128.13-1.028-1.072.129-.128a2.24 2.24 0 0 0 .728-1.67c0-.643-.214-1.242-.685-1.714-.257-.257-.514-.47-.857-.6V9.27a3.8 3.8 0 0 1 1.97 1.114M9.402 6.058l-.728.728 1.028 1.07.728-.685c.728-.685 1.842-.685 2.527.043.686.728.686 1.842-.043 2.527l-.728.686 1.028 1.07.729-.685c1.327-1.242 1.327-3.34.085-4.669-1.242-1.284-3.298-1.327-4.626-.085"
  })));
};
export default SvgDunbradstreet;